// HOOK OF INPUT
import TextareaAutosize            from '@material-ui/core/TextareaAutosize';
import React, {Fragment, useState} from 'react'

export default function useArea({type, placeholder, initialState, maxLength, maxHeight, rows, var1, var2, var3, defaulted}) {
    const [value, setValue] = useState(initialState ? initialState : ''),
            input = (
                <Fragment>
                    <TextareaAutosize
                        onChange    = {({target}) => setValue(target.value)}
                        placeholder = {placeholder ? placeholder : ''}
                        maxLength   = {maxLength ? maxLength : 255}
                        type        = {type ? type : 'textArea'}
                        maxRows     = {rows ? rows : 5}
                        value       = {value}
                        style       = {{
                            width: "100%",
                            height: `${maxHeight ? maxHeight : "150px"}`,
                            border: '1px solid #E5E7EB',
                            resize: 'none'
                        }}
                    />
                    <div className="max-text">
                        {maxLength !== 255 ? '' : (`${maxLength - value.length} de ${maxLength}`)}
                    </div>
                    <style jsx={"true"}>{`
                    .max-text {
                        color: #8E929B;
                        font-size: 10px;
                        text-align: right;
                    }

                    `}</style>
                </Fragment>
            )
    return {
        get: value,
        input,
        set: setValue
    }
}